export default class BackgroundVideo {
    constructor(obj = {}) {
        this.url = '';
        this.img = '';
        this.range = [];
        this.dim = [];
        SetDesign.whitelistAssign(this, obj);
    }

    matches(width) {
        return width >= this.range[0];
    }

    paths() {
        return { mp4: this.url, poster: this.img };
    }

    pad() {
        return (this.dim[1] / this.dim[0]) * 100;
    }
}
